import { RouteObject, Navigate } from 'react-router-dom';

export const deliveryRoutes: RouteObject[] = [
  {
    path: '',
    element: <Navigate to="/projects/management/projects" replace />,
  },
  {
    path: 'projects',
    element: <Navigate to="/projects/management/projects" replace />,
    handle: { crumb: 'Projects' },
  },
  {
    path: 'time',
    element: <Navigate to="/projects/time/time-entries" replace />,
    handle: { crumb: 'Time Logs' },
  },
  {
    path: '*',
    element: <Navigate to="/projects/management/projects" replace />,
  },
];

export default deliveryRoutes;
